export enum LastTestRequestedGroup {
  DAYS_0_TO_2 = 'DAYS_0_TO_2',
  DAYS_3_TO_6 = 'DAYS_3_TO_6',
  DAYS_7_TO_14 = 'DAYS_7_TO_14',
  DAYS_15_PLUS = 'DAYS_15_PLUS',
  NEVER = 'NEVER',
}

export const LAST_TEST_REQUESTED_OPTIONS: { id: LastTestRequestedGroup; label: string }[] = [
  { id: LastTestRequestedGroup.DAYS_0_TO_2, label: '0–2 days ago' },
  { id: LastTestRequestedGroup.DAYS_3_TO_6, label: '3–6 days ago' },
  { id: LastTestRequestedGroup.DAYS_7_TO_14, label: '7–14 days ago' },
  { id: LastTestRequestedGroup.DAYS_15_PLUS, label: '15+ days ago' },
  { id: LastTestRequestedGroup.NEVER, label: 'Never' },
];
